<aside class="nav2" [class.nav2-collapsed]="nav.collapsed()">
  <header class="nav2-header">
    <img class="nav2-logo" [src]="logo()" alt="Company logo" width="110" height="30" />
    <button
      type="button"
      class="nav2-pin"
      (click)="nav.toggleCollapsed()"
      [title]="nav.collapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
      [attr.aria-label]="nav.collapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
      [attr.aria-expanded]="!nav.collapsed()">
      <app-svg-icons icons="double-arrow-left" width="16" height="16" />
    </button>
  </header>

  <nav class="nav2-scroll" aria-label="Main navigation">
    @if (pinnedItems().length) {
      <div class="nav2-section">
        <p class="nav2-section-label">Pinned</p>
        <ul class="nav2-list">
          @for (p of pinnedItems(); track p.key) {
            <li class="nav2-row">
              @if (p.url) {
                <a
                  class="nav2-item"
                  [routerLink]="p.url"
                  [class.active]="isActive(p.url)"
                  [attr.aria-current]="isActive(p.url) ? 'page' : null"
                  [attr.title]="p.origin + ' · ' + p.label">
                  <app-svg-icons [icons]="p.icon" width="20" height="20" />
                  <span class="nav2-label">{{ p.label }}</span>
                </a>
              } @else {
                <button type="button" class="nav2-item" (click)="onAction(p)" [attr.title]="p.origin + ' · ' + p.label">
                  @if (p.key === 'my-tasks' && initials()) {
                    <span class="nav2-task-avatar">
                      {{ initials() }}
                      @if (myTasksBadge()) {
                        <span class="nav2-task-badge">{{ myTasksBadge() }}</span>
                      }
                    </span>
                  } @else {
                    @if (p.key === 'my-reminders') {
                      <span class="nav2-icon-wrap">
                        <app-svg-icons [icons]="p.icon" width="20" height="20" />
                        @if (myRemindersBadge()) {
                          <span class="nav2-task-badge">{{ myRemindersBadge() }}</span>
                        }
                      </span>
                    } @else {
                      <app-svg-icons [icons]="p.icon" width="20" height="20" />
                    }
                  }
                  <span class="nav2-label">{{ p.label }}</span>
                </button>
              }
              <button
                type="button"
                class="nav2-pin-btn is-pinned"
                (click)="togglePin(p.key, $event)"
                aria-pressed="true"
                [attr.aria-label]="'Unpin ' + p.label"
                title="Unpin">
                <app-svg-icons icons="keep-fill" width="13" height="13" />
              </button>
            </li>
          }
        </ul>
      </div>
    }
    @for (section of sections(); track section.label) {
      <div class="nav2-section">
        <p class="nav2-section-label">{{ section.label }}</p>
        <ul class="nav2-list">
          @for (item of section.items; track item.id) {
            <li class="nav2-row">
              @if (item.children) {
                <button
                  type="button"
                  class="nav2-item nav2-parent"
                  [class.active]="activeParentId() === item.id"
                  [class.open]="!nav.collapsed() && nav.isSectionOpen(item.id)"
                  (click)="onParentClick(item, $event)"
                  [attr.aria-expanded]="nav.collapsed() ? flyout()?.item?.id === item.id : nav.isSectionOpen(item.id)"
                  [attr.title]="nav.collapsed() ? item.label : null">
                  <app-svg-icons [icons]="item.icon" width="20" height="20" />
                  <span class="nav2-label">{{ item.label }}</span>
                  <span class="nav2-chevron"><app-svg-icons icons="keyboard_arrow_right" width="18" height="18" /></span>
                </button>
                <div class="nav2-sub" [class.open]="!nav.collapsed() && nav.isSectionOpen(item.id)">
                  <div class="nav2-sub-inner">
                    <ul class="nav2-children">
                      @for (child of item.children; track child.url) {
                        <li class="nav2-row">
                          <a
                            class="nav2-item nav2-child"
                            [routerLink]="child.url"
                            [class.active]="isActive(child.url)"
                            [attr.aria-current]="isActive(child.url) ? 'page' : null">
                            <app-svg-icons [icons]="child.icon" width="17" height="17" />
                            <span class="nav2-label">{{ child.label }}</span>
                          </a>
                          <button
                            type="button"
                            class="nav2-pin-btn"
                            [class.is-pinned]="nav.isPinned(child.url)"
                            (click)="togglePin(child.url, $event)"
                            [attr.aria-pressed]="nav.isPinned(child.url)"
                            [attr.aria-label]="(nav.isPinned(child.url) ? 'Unpin ' : 'Pin ') + child.label"
                            [attr.title]="nav.isPinned(child.url) ? 'Unpin' : 'Pin'">
                            @if (nav.isPinned(child.url)) {
                              <app-svg-icons icons="keep-fill" width="13" height="13" />
                            } @else {
                              <app-svg-icons icons="keep" width="13" height="13" />
                            }
                          </button>
                        </li>
                      }
                    </ul>
                  </div>
                </div>
              } @else if (item.action) {
                <button type="button" class="nav2-item" (click)="onActionItemClick(item, $event)"
                  (dblclick)="onActionItemDblClick(item)"
                  [attr.title]="(nav.collapsed() ? item.label : '') + (item.id === 'my-tasks' && myTasksBadge() ? (nav.collapsed() ? ' — ' : '') + myTasksBadge() + ' open assigned to me' : '') || null">
                  @if (item.id === 'my-tasks' && initials()) {
                    <span class="nav2-task-avatar">
                      {{ initials() }}
                      @if (myTasksBadge()) {
                        <span class="nav2-task-badge">{{ myTasksBadge() }}</span>
                      }
                    </span>
                  } @else {
                    @if (item.id === 'my-reminders') {
                      <span class="nav2-icon-wrap">
                        <app-svg-icons [icons]="item.icon" width="20" height="20" />
                        @if (myRemindersBadge()) {
                          <span class="nav2-task-badge">{{ myRemindersBadge() }}</span>
                        }
                      </span>
                    } @else {
                      <app-svg-icons [icons]="item.icon" width="20" height="20" />
                    }
                  }
                  <span class="nav2-label">{{ item.label }}</span>
                </button>
                <button
                  type="button"
                  class="nav2-pin-btn"
                  [class.is-pinned]="nav.isPinned(item.id)"
                  (click)="togglePin(item.id, $event)"
                  [attr.aria-pressed]="nav.isPinned(item.id)"
                  [attr.aria-label]="(nav.isPinned(item.id) ? 'Unpin ' : 'Pin ') + item.label"
                  [attr.title]="nav.isPinned(item.id) ? 'Unpin' : 'Pin'">
                  @if (nav.isPinned(item.id)) {
                    <app-svg-icons icons="keep-fill" width="13" height="13" />
                  } @else {
                    <app-svg-icons icons="keep" width="13" height="13" />
                  }
                </button>
                @if (item.id === 'my-tasks' && pipSupported) {
                  <button type="button" class="nav2-pin-btn nav2-pip-btn" (click)="pinMyTasks($event)"
                    aria-label="Pin My Tasks to an always-on-top window" title="Pin to an always-on-top window">
                    <app-svg-icons icons="pip" width="13" height="13" />
                  </button>
                }
              } @else {
                <a
                  class="nav2-item"
                  [routerLink]="item.url"
                  [class.active]="isActive(item.url)"
                  [attr.aria-current]="isActive(item.url) ? 'page' : null"
                  [attr.title]="nav.collapsed() ? item.label : null">
                  <app-svg-icons [icons]="item.icon" width="20" height="20" />
                  <span class="nav2-label">{{ item.label }}</span>
                </a>
                <button
                  type="button"
                  class="nav2-pin-btn"
                  [class.is-pinned]="nav.isPinned(item.url ?? item.id)"
                  (click)="togglePin(item.url ?? item.id, $event)"
                  [attr.aria-pressed]="nav.isPinned(item.url ?? item.id)"
                  [attr.aria-label]="(nav.isPinned(item.url ?? item.id) ? 'Unpin ' : 'Pin ') + item.label"
                  [attr.title]="nav.isPinned(item.url ?? item.id) ? 'Unpin' : 'Pin'">
                  @if (nav.isPinned(item.url ?? item.id)) {
                    <app-svg-icons icons="keep-fill" width="13" height="13" />
                  } @else {
                    <app-svg-icons icons="keep" width="13" height="13" />
                  }
                </button>
              }
            </li>
          }
        </ul>
      </div>
    }
  </nav>

  <footer class="nav2-footer">
    <a class="nav2-foot-btn nav2-hide-collapsed" routerLink="/notifications" title="Notifications" aria-label="Notifications">
      <app-svg-icons icons="notifications" width="18" height="18" />
    </a>
    <a class="nav2-foot-btn nav2-hide-collapsed" routerLink="/help" title="Help" aria-label="Help">
      <app-svg-icons icons="help" width="18" height="18" />
    </a>
    <a class="nav2-foot-btn nav2-hide-collapsed" routerLink="settings/change-password" title="Settings" aria-label="Settings">
      <app-svg-icons icons="setting" width="18" height="18" />
    </a>
    <button type="button" class="nav2-foot-btn" (click)="themeService.toggle()" [title]="themeTitle()" [attr.aria-label]="themeTitle()">
      @switch (themeService.theme()) {
        @case ('light') {
          <app-svg-icons icons="light-mode" width="18" height="18" />
        }
        @case ('soft') {
          <app-svg-icons icons="partly-cloudy-day" width="18" height="18" />
        }
        @case ('dark') {
          <app-svg-icons icons="dark-mode" width="18" height="18" />
        }
      }
    </button>
    <button type="button" class="nav2-avatar" (click)="toggleProfile($event)" title="Account" aria-label="Account">
      {{ initials() }}
    </button>
    <div class="nav2-versions" [attr.title]="'Frontend v' + feVersion + (beVersion() ? ' | Backend v' + beVersion() : '')">
      <span>FE {{ feVersion }}</span>
      @if (beVersion()) {
        <span>BE {{ beVersion() }}</span>
      }
    </div>
  </footer>
  <div class="nav2-date-row" [class.date-in-clock]="clockWidget.enabled() && clockWidget.dateInClock()" [class.clock-hidden]="!clockWidget.enabled()">
    <span class="nav2-date" [title]="clockWidget.calendarDateTitle()" [attr.aria-label]="clockWidget.calendarDateTitle()">
      @if (!clockWidget.enabled()) {
        <span class="nav2-date-day" aria-hidden="true">{{ clockWidget.calendarDay() }}</span>
        <span class="nav2-date-month" aria-hidden="true">{{ clockWidget.calendarMonth() }}</span>
      } @else {
        {{ clockWidget.calendarDate() }}
      }
    </span>
  </div>

  @if (flyout(); as f) {
    <div class="nav2-flyout" [style.top.px]="f.top" [style.maxHeight.px]="f.maxHeight" role="menu" [attr.aria-label]="f.item.label">
      <p class="nav2-flyout-title">{{ f.item.label }}</p>
      <ul>
        @for (child of f.item.children ?? []; track child.url) {
          <li class="nav2-row">
            <a
              class="nav2-item nav2-child"
              [routerLink]="child.url"
              (click)="closeFlyout()"
              [class.active]="isActive(child.url)"
              [attr.aria-current]="isActive(child.url) ? 'page' : null">
              <app-svg-icons [icons]="child.icon" width="17" height="17" />
              <span class="nav2-label">{{ child.label }}</span>
            </a>
            <button
              type="button"
              class="nav2-pin-btn"
              [class.is-pinned]="nav.isPinned(child.url)"
              (click)="togglePin(child.url, $event)"
              [attr.aria-pressed]="nav.isPinned(child.url)"
              [attr.aria-label]="(nav.isPinned(child.url) ? 'Unpin ' : 'Pin ') + child.label"
              [attr.title]="nav.isPinned(child.url) ? 'Unpin' : 'Pin'">
              @if (nav.isPinned(child.url)) {
                <app-svg-icons icons="keep-fill" width="13" height="13" />
              } @else {
                <app-svg-icons icons="keep" width="13" height="13" />
              }
            </button>
          </li>
        }
      </ul>
    </div>
  }

  @if (profileOpen()) {
    <div class="nav2-profile-card">
      <div class="nav2-profile-head">
        <div class="nav2-profile-avatar">{{ initials() }}</div>
        <div class="nav2-profile-meta">
          <h3>{{ user()?.name }}</h3>
          <p>{{ user()?.email }}</p>
        </div>
      </div>
      <ul class="nav2-profile-actions">
        <li>
          <a routerLink="/profile">
            <app-svg-icons icons="person" width="16" height="16" />
            <span>Profile</span>
          </a>
        </li>
        <li>
          <a routerLink="settings/change-password">
            <app-svg-icons icons="password-m" width="16" height="16" />
            <span>Change Password</span>
          </a>
        </li>
        <li class="nav2-profile-divider"></li>
        <li>
          <button type="button" (click)="handleLogout()">
            <app-svg-icons icons="logout" width="16" height="16" />
            <span>Logout</span>
          </button>
        </li>
      </ul>
    </div>
  }
</aside>

<app-fullpage-loading text="Logging out..." [loading]="loading" />
